<template>
  <div class="hero dark">
    <div class="row">
      <div class="col hero-content">
        <div class="hero-text slide-in"
          :class="{
            'visible': visible
          }">
          <router-link :to="{ name: 'virtual' }">
            <svg class="hero-logo">
              <use v-if="selectedTranslation === 'en'" xlink:href="#logoWmkSvgEng"></use>
              <use v-else xlink:href="#logoWmkSvg"></use>
            </svg>
          </router-link>
          <div v-if="!isPhone && buttonData.seeCollection">
            <router-link :to="{ name: 'virtual' }" class="btn btn-simple">
              {{ buttonData.seeCollection }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="hero-image" :style="'background-image: url(' + telegraphBg + ')'">
        <img :src="telegraphImage" ref="hero-image" alt="telegraph" />
      </div>
    </div>
    <div class="hero-addons">
      <router-link :to="{ name: 'virtual' }" class="btn btn-simple" v-if="isPhone && buttonData.seeCollection">
        {{ buttonData.seeCollection }}
      </router-link>
      <p v-else-if="virtualData.info" class="text-m paragraph">
        {{ virtualData.info }}
      </p>
    </div>
  </div>
</template>

<script>
import telegraphBg from '@/assets/images/cekt/kopiarka-bg.png'
import telegraphImage from '@/assets/images/categories/static/telegraphs-frame.gif'
import telegraphImageGif from '@/assets/images/categories/rest/telegraphs.gif'
import telegraphImageGifHD from '@/assets/images/categories/telegraphs.gif'

import { mapGetters } from 'vuex'

export default {
  name: 'VirtualMuseumSection',
  props: ['visible'],
  data () {
    return {
      telegraphBg: telegraphBg,
      telegraphImage: telegraphImage,
      gifLoaded: false,
      gifHDLoaded: false
    }
  },
  computed: {
    ...mapGetters([
      'breakpoint',
      'buttonData',
      'virtualData',
      'selectedTranslation'
    ]),
    isMobile () {
      return this.breakpoint === 'mobile' || this.breakpoint === 'tablet'
    },
    isPhone () {
      return this.breakpoint === 'mobile'
    }
  },
  methods: {
    loadImage (imgToLoad, loadedImage, loaded, callback) {
      const _t = this
      if (loaded) {
        _t.$refs[imgToLoad].src = loadedImage
        return false
      }
      let img = new Image()
      img.onload = () => {
        _t.$refs[imgToLoad].src = loadedImage
        _t.telegraphImage = loadedImage
        loaded = true

        if (typeof callback === 'function') {
          callback()
        }
      }
      img.src = loadedImage
    },
    loadAnimation (isMobile) {
      const _t = this
      if (isMobile) {
        _t.$refs['hero-image'].src = telegraphImage
      } else {
        _t.loadImage('hero-image', telegraphImageGif, _t.gifLoaded, function () {
          if (!_t.gifHDLoaded) {
            _t.loadImage('hero-image', telegraphImageGifHD, _t.gifHDLoaded)
          }
        })
      }
    }
  },
  watch: {
    breakpoint (newVal, oldVal) {
      if (newVal === 'mobile') {
        this.loadAnimation(true)
      }
    }
  },
  mounted () {
    this.loadAnimation(this.isPhone)
  }
}
</script>

<style scoped lang="scss">
  .hero {
    background: #0e161e;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    justify-items: center;
    padding: $gap-xl 0 $gap-md;
    position: relative;

    .row {
      position: relative;
      min-height: 100%;
      padding-bottom: $gap-md;
      padding-top: $gap-md;
    }

    .row,
    &-addons {
      margin: 0 auto;
      text-align: right;
      width: calc(100% - #{($gap-md * 2)});
      max-width: calc(100% - #{($gap-md * 2)});
    }

    &-content {
      padding: 0;
    } // END .hero-content

    &-logo {
      fill: $text-light;
      height: 46px;
      width: 170px;
    }

    &-text {
      margin: 0 0 50px 0;
      min-height: 100px;
      padding: 0;
      text-align: left;
      width: 100%;
      max-width: 350px;

      .btn-simple {
        margin-top: $gap-md;
      }
    } // END .hero-text;

    &-image {
      background: {
        color: transparent;
        repeat: no-repeat;
        position: 50% 50%;
        size: cover;
      }
      margin-bottom: ($gap-xl * -1);
      position: relative;
      top: ($gap-xl * -1);
      text-align: center;
      width: 100%;

      img {
        height: auto;
        width: auto;
        max-width: 100%;
      }
    } // END .hero-image;

    &-addons {
      padding: 0;
      text-align: right;
    } // END .hero-addons;

    .btn-simple {
      border-color: transparent;

      &:hover, &:focus {
        color: $text-light;
      }
    }

    @include screen ('sm') {
      min-height: 720px;
      overflow: hidden;

      .row,
      &-addons {
        max-width: 88vw;
      }

      &-logo {
        height: 80px;
        width: 297px;
      }

      &-image {
        background-size: contain;
        margin: 0;
        min-height: 720px;
        height: 100%;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 50%;

        img {
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 10;
        }
      } // END .hero-image;

      &-addons {
        bottom: 100px;
        left: 50%;
        position: absolute;
        text-align: left;
        transform: translateX(-50%);
      } // END .hero-addons;

      .btn-simple {
        border-color: $text-accent;
      }
    } // END @include screen ('sm');

    @include screen ('md') {
      .row,
      &-addons {
        width: calc(100% - #{($gap-md * 2)});
        max-width: $container-content-max-width;
      } // END .hero-addons;

      &-content,
      &-addons {
        padding-left: ($gap-xl * 2.5);
      }
    } // END @include screen ('md');

    @include screen ('lg') {
      &-content,
      &-addons {
        padding-left: $gap-xl;
      }
    } // END @include screen ('lg');

    @include screen ('xl') {
      &-content,
      &-addons {
        padding-left: 0;
      }
    }

  } // END .hero;
</style>
